import type { IDecimalValueAndUnit } from '@/interfaces'

class DecimalValueAndUnit implements IDecimalValueAndUnit {
  value: number

  unit: string

  constructor(item?: any) {
    this.value = this.isValidValue(item?.value) ? item.value : 0
    this.unit = item?.unit ?? null
  }

  private isValidValue(value: any): boolean {
    return value !== null && value !== undefined && value !== ''
  }
}

export default DecimalValueAndUnit
